import React from 'react'
import Complete from './complete'
import Warning from './warning'

const Upshot = props => {
    let { status, paymentData, paymentInfo, additionalData = {} } = props

    switch (status) {
        case 'complete':
            return (
                <Complete paymentData={paymentData} paymentInfo={paymentInfo} />
            )
            break
        case 'warning':
            return (
                <Warning
                    paymentData={paymentData}
                    paymentInfo={paymentInfo}
                    additionalData={additionalData}
                />
            )
            break
    }
}

export default Upshot
